'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = extendsSchema;

var _codevTraverse = require('codev-traverse');

function extendsMiddleware(createProps) {
  var middleware = function middleware(schema) {
    return function () {
      return function (next) {
        return function () {
          var contents = next(schema.contents);

          var result = Object.assign({}, schema, createProps(schema));

          if (!contents) return result;
          return Object.assign(result, { contents: contents });
        };
      };
    };
  };

  return middleware;
} /**
   * traverse schema 中的每個 field setting，傳回新的 field setting
   * - 用來在 schema 上加上 validator
   * - 用來收集 schema 上的資訊，例如收集所有 reference
   */
function extendsSchema(schema, createProps) {
  return (0, _codevTraverse.traverse)(schema)(extendsMiddleware(createProps))()();
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/schema/extendsSchema.js
// module id = 1069
// module chunks = 0